/**
 * Message modules: every module declares English (source) plus zh and ms with EXACTLY the same keys.
 * Missing or extra keys are compile errors, and test/i18n-nav.test.ts double-checks at runtime.
 */
export function msgs<const E extends Record<string, string>>(m: { en: E; zh: { [K in keyof E]: string }; ms: { [K in keyof E]: string } }) {
  return m;
}
